import type { EmployeeFormData } from './EmployeeDialog';

/** Group fields of CreateEmployeeRequest (FACF-149). */
export function timeClockGroupForCreate(data: EmployeeFormData) {
  return { timeClockGroupId: data.timeClockGroupId || null };
}

/**
 * Group fields of UpdateEmployeeRequest: `timeClockGroupId: null` means "unchanged" there, so
 * switching back to the tenant default needs `clearTimeClockGroup`.
 */
export function timeClockGroupForUpdate(data: EmployeeFormData) {
  return data.timeClockGroupId
    ? { timeClockGroupId: data.timeClockGroupId, clearTimeClockGroup: false }
    : { timeClockGroupId: null, clearTimeClockGroup: true };
}
